import React from 'react';

type K = (e: KeyboardEvent | React.KeyboardEvent) => boolean;
type M = (e: MouseEvent | React.MouseEvent) => boolean;
export const isLeftMouseButtonEvent: M = (e): boolean => e.button === 0;
export const isWheelMouseButtonEvent: M = (e): boolean => e.button === 1;

const isKey =
  (key: string): K =>
  (e: KeyboardEvent | React.KeyboardEvent) =>
    e.key === key;

export const isEscapeKey = isKey('Escape');
export const isControlKeyOn = (e: React.MouseEvent | React.KeyboardEvent): boolean => e.ctrlKey;
export const isCommandKeyOn = (e: React.MouseEvent | React.KeyboardEvent): boolean => e.metaKey;
